import CustomTable from "@/shared/components/common/table";
import CustomButton from "@/shared/components/kit/button";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
/**
 * ContentTableAddUser
 *
 * کامپوننتی برای نمایش جدول کاربران اضافه شده با قابلیت:
 * - تعریف ستون‌های جدول با dataHeader شامل شناسه، نام فروشگاه، تاریخ صدور، مبلغ امتیاز و عملیات
 * - رندر داده‌های نمونه (fakeData) برای نمایش اولیه
 * - امکان افزودن المان‌های JSX مانند دکمه‌های ویرایش در هر ردیف
 * - استفاده از کامپوننت CustomTable برای نمایش ساختار جدول
 *
 * @returns JSX.Element
 */
const ContentTableAddUser = () => {
  const dataHeader = [
    { id: "id", title: "شماره" },
    { id: "datetime", title: "نام فروشگاه" },
    { id: "amount", title: "تاریخ صدور" },
    { id: "type", title: "مبلغ امتیاز( ریال)" },
    { id: "test", title: "testType)" },

    { id: "moreElement", title: "" },
    { id: "buttonDetail", title: "" },
  ];
  const fakeData = [
    {
      id: 1,
      datetime: "فروشگاه شوکا",
      amount: "5,000,000,000",
      type: "5,000,000,000",
      test: "testType",
      moreElement: (
        <CustomButton>
          <TypoGraphyKit>ویرایش</TypoGraphyKit>
        </CustomButton>
      ),
      buttonDetail: (
        <CustomButton>
          <TypoGraphyKit>ویرایش</TypoGraphyKit>
        </CustomButton>
      ),
    },
    {
      id: 2,
      datetime: "15:40 - 1403/05/12",
      amount: "5,000,000",
      type: "انتقال وجه",
      moreElement: (
        <CustomButton>
          <TypoGraphyKit>ویرایش</TypoGraphyKit>
        </CustomButton>
      ),
      buttonDetail: (
        <CustomButton>
          <TypoGraphyKit>ویرایش</TypoGraphyKit>
        </CustomButton>
      ),
    },
  ];
  return <CustomTable dataHeader={dataHeader} dataTbody={fakeData} />;
};

export default ContentTableAddUser;
